import DestinationTripsTemplate from "./DestinationTripsTemplate";
import { Castle } from "lucide-react";

const Disneyland = () => {
  return (
    <DestinationTripsTemplate
      destinationId="disneyland"
      destinationName="Disneyland Resort"
      destinationIcon={Castle}
      destinationDescription="Create magical Disneyland experiences for your clients"
      destinationFeatures="Disneyland Park • California Adventure • Downtown Disney • Disneyland Hotel • Grand Californian • Paradise Pier"
    />
  );
};

export default Disneyland;
